import { Rx } from "subtree.js/core";
import type { CredentialErrors, Credentials } from "../../core/primitives/credentials";

export class LoginState {
  readonly draft = new Rx<Credentials>({ email: "", password: "" });
  /** Per-field messages from the last submit; re-checked on every change after that. */
  readonly fieldErrors = new Rx<CredentialErrors>({});
  readonly error = new Rx<string | null>(null);
  readonly info = new Rx<string | null>(null);
  readonly busy = new Rx(false);
}

export abstract class LoginActions {
  abstract setEmail(value: string): void;
  abstract setPassword(value: string): void;
  abstract submit(): Promise<void>;
  abstract continueWithGoogle(): Promise<void>;
}
